import React, { memo } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { definition as faSync } from '@fortawesome/free-solid-svg-icons/faSync';
import { defaultGroups } from './defaultGroups';
import { defaultApplySetting } from './defaultApplySetting';
import { defaultGetSettings } from './cookie';
import { ActionButton } from './ActionButton';
import { SettingsGroup } from './SettingsGroup';
import { useSettigs } from './useSettings';
import { settingsPanel, settingsPanelGroups, settingsPanelButtons, settingsPanelButtonsRight } from './classNames';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

function SettingsPanelInner(_ref) {
  var _ref$groups = _ref.groups,
      groups = _ref$groups === void 0 ? defaultGroups : _ref$groups,
      _ref$getSettings = _ref.getSettings,
      getSettings = _ref$getSettings === void 0 ? defaultGetSettings : _ref$getSettings,
      _ref$restoreButtonTex = _ref.restoreButtonText,
      restoreButtonText = _ref$restoreButtonTex === void 0 ? 'Вернуть стандартные настройки' : _ref$restoreButtonTex,
      _ref$closeButtonText = _ref.closeButtonText,
      closeButtonText = _ref$closeButtonText === void 0 ? 'Закрыть панель' : _ref$closeButtonText,
      handleClose = _ref.handleClose,
      _ref$applySetting = _ref.applySetting,
      applySetting = _ref$applySetting === void 0 ? defaultApplySetting : _ref$applySetting;

  var _useSettigs = useSettigs({
    getSettings: getSettings,
    groups: groups,
    applySetting: applySetting
  }),
      values = _useSettigs.values,
      setValue = _useSettigs.setValue,
      handleRestore = _useSettigs.handleRestore;

  return /*#__PURE__*/_jsxs("div", {
    className: settingsPanel,
    children: [/*#__PURE__*/_jsx("div", {
      className: settingsPanelGroups,
      children: groups.map(function (group) {
        var property = group.property;
        return /*#__PURE__*/_jsx(SettingsGroup, {
          group: group,
          value: values[property],
          setValue: setValue
        }, group.property);
      })
    }), /*#__PURE__*/_jsxs("div", {
      className: settingsPanelButtons,
      children: [/*#__PURE__*/_jsx("div", {
        className: settingsPanelButtonsRight,
        children: /*#__PURE__*/_jsx(ActionButton, {
          onClick: handleClose,
          children: closeButtonText
        })
      }), /*#__PURE__*/_jsxs(ActionButton, {
        onClick: handleRestore,
        children: [/*#__PURE__*/_jsx(FontAwesomeIcon, {
          icon: faSync,
          rotation: 90,
          size: "xs",
          fixedWidth: true
        }), ' ', restoreButtonText]
      })]
    })]
  });
}

export var SettingsPanel = /*#__PURE__*/memo(SettingsPanelInner);